import React from "react";
import { Col, Row } from "react-bootstrap";

function OrderManagement({ orders }) {
  return (
    <Row className="d-flex gap-1 flex-wrap">
      <Col xl={5} className=" d-flex align-items-center gap-1">
        <div className=" fw-bold  text-black"> Name:</div>{" "}
        <div className=" fw-bold "> {orders?.first_name}</div>
      </Col>

      <Col xl={5} className=" d-flex align-items-center gap-1">
        {" "}
        <div className=" fw-bold  text-black"> Email:</div>{" "}
        <div className=" fw-bold "> {orders?.email}</div>
      </Col>

      <Col xl={5} className=" d-flex align-items-center gap-1">
        {" "}
        <div className=" fw-bold  text-black"> Assigned To:</div>{" "}
        <div className=" fw-bold "> {orders?.assigned_to}</div>
      </Col>

      <Col xl={5} className="d-flex align-items-center gap-1">
        <div className=" fw-bold  text-black"> Phone:</div>{" "}
        <div className="fw-bold "> {orders?.phone_number}</div>
      </Col>

      <Col xl={5} className="d-flex align-items-center gap-1">
        <div className=" fw-bold  text-black"> Gender:</div>{" "}
        <div className="fw-bold "> {orders?.gender}</div>
      </Col>

      <Col xl={5} className="d-flex align-items-center gap-1">
        <div className=" fw-bold  text-black"> Stages:</div>{" "}
        <div className="fw-bold "> {orders?.stage}</div>
      </Col>
    </Row>
  );
}

export default OrderManagement;
